export default {
	styleBeforeLoad: {
		zIndex: "0",
		position: "fixed",
		bottom: "0",
		right: "0",
		left: "auto",
		top: "auto",
		height: "0",
		width: "0",
		border: "none",
		display: "none",
	},
	flow: {
		width: "100%",
		height: "100%",
		border: "none",
	},
	widget: {
		closed: {
			zIndex: "999999",
			position: "fixed",
			bottom: "0",
			right: "0",
			left: "auto",
			top: "auto",
			height: "90px",
			minHeight: "90px",
			width: "100px",
			border: "none",
			display: "block",
		}
	}
};
